import React from 'react';
import customStyles from "../../../../../assets/styles/customStyles";
import clsx from "clsx";
import { Row, Col } from "antd";
import moment from 'moment';
import { displayPan, } from "../../../../../helpers/utilities";
import { SalesLines } from "./inc/Components";
import FileUpload from "../../FileUpload";

export const Format1 = React.forwardRef((props, ref) => {
    const { details, preview, copy, sAddress, proformaPreview, businessDetails, count } = props;
    const classes = customStyles();
    let placeOfSupply = !preview ? sAddress.split("@@@") : '';

    const address = (details) => {
        let address = details?.address || details?.address1 || '';
        address += address !== '' ? ', ' : '';
        address += details?.area && details?.area?.name ? details?.area?.name : '';
        return address;
    }

    const address1 = (details) => {
        let address = details?.city && details?.city?.name ? details?.city?.name + ' - ' : '---';
        address += details?.pincode && details?.pincode?.code ? details?.pincode?.code : '---';
        address += details?.state && details?.state?.name ? ', ' + details?.state?.name : '---';
        address += details?.country && details?.country?.name ? ', ' + details?.country?.name : '---';
        return address;
    }

    // const addressShipped = (sAddress) => {
    //     if (!preview) {
    //         let sKey = sAddress.split("-");
    //         let address = sKey[0] || '';
    //         address += address !== '' ? ', ' : '';
    //         address += sKey[1] || '';
    //         return address;
    //     } else {
    //         return false;
    //     }
    // }

    // const address1Shipped = (sAddress) => {
    //     if (!preview) {
    //         let sKey = sAddress.split("-");
    //         let address = sKey[2] ? sKey[2] + ' - ' : '---';
    //         address += sKey[3] ? sKey[3] : '---';
    //         address += sKey[4] ? ', ' + sKey[4] : '---';
    //         address += sKey[5] ? ', ' + sKey[5] : '---';
    //         return address;
    //     } else {
    //         return false;
    //     }
    // }
    return (
        <div className={classes.printFullPage}>
            {count > 1 ? <div className="page-break"></div> : ''}
            <div className={classes.downloadbars}>
                <div className={classes.downloadtopbar}></div>
                {
                    proformaPreview ? <div style={{ fontFamily: '"RobotoMedium", "Roboto"' }} className={classes.downloadsecondbar}>Estimate</div> :
                        <div style={{ fontFamily: '"RobotoMedium", "Roboto"' }} className={classes.downloadsecondbar}>
                            {
                                copy ? 'Purchase Order' : 'Request For Quotation'
                            }
                            {
                                details?.supply_quote_status === 'CANCELLED' ? ' - Cancelled' : ''
                            }
                        </div>
                }
            </div>
            <div className={classes.downloaddetails}>
                <Row>
                    {
                        (details?.business?.logoUri || businessDetails?.logoUri) &&
                        <Col xxl={5} xl={5} lg={5} md={5} sm={5} xs={5} className={classes.dispalyIF}>
                            <div className={clsx(classes.productImageUpload, classes.dropDown)}>
                                <FileUpload
                                    filePath={details?.business?.logoUri || businessDetails?.logoUri || ''}
                                    view={true}
                                />
                            </div>
                        </Col>
                    }
                    <Col xxl={details?.business?.logoUri || businessDetails?.logoUri ? 19 : 24} xl={details?.business?.logoUri || businessDetails?.logoUri ? 19 : 24}
                        lg={details?.business?.logoUri || businessDetails?.logoUri ? 19 : 24} md={details?.business?.logoUri || businessDetails?.logoUri ? 19 : 24}
                        sm={details?.business?.logoUri || businessDetails?.logoUri ? 19 : 24} xs={details?.business?.logoUri || businessDetails?.logoUri ? 19 : 24}>
                        <Row className={clsx(classes.yellowBorderTop)}>
                            <Col xxl={12} xl={12} lg={12} md={12} sm={12} xs={12} className={clsx(classes.borderRight, classes.bill, classes.billtoppadding)}>
                                <h6>Registered Address</h6>
                                <p>{preview ? <span className={clsx(classes.greyBg, classes.smallWidth)}></span> : details?.business?.name || businessDetails?.businessName || '---'}</p>
                                <p>{preview ? <span className={clsx(classes.greyBg, classes.largeWidth)}></span> : address(details?.business || businessDetails)}</p>
                                <p>{preview ? <span className={clsx(classes.greyBg, classes.mediumWidth)}></span> : address1(details?.business || businessDetails)}</p>
                            </Col>
                            <Col xxl={12} xl={12} lg={12} md={12} sm={12} xs={12} className={clsx(classes.bill, classes.billtoppadding)}>
                                <h6>Shipped To</h6>
                                <p>{preview ? <span className={clsx(classes.greyBg, classes.smallWidth)}></span> : details?.business?.name || businessDetails?.businessName || '---'}</p>
                                <p>{preview ? <span className={clsx(classes.greyBg, classes.largeWidth)}></span> : address(details)}</p>
                                <p>{preview ? <span className={clsx(classes.greyBg, classes.mediumWidth)}></span> : address1(details)}</p>
                            </Col>
                        </Row>
                        <Row>
                            <Col span={12} className={clsx(classes.borderRight, classes.bill, classes.billbottompadding)}>
                                <Row>
                                    <Col span={24}>
                                        <Row>
                                            <Col span={4}>
                                                <h6>Email</h6>
                                            </Col>
                                            <Col span={20}>
                                                <p className={clsx(classes.emailText)}>{preview ? <span className={clsx(classes.greyBg, classes.mediumWidth)}></span> : businessDetails?.email || details?.business?.email || '---'}</p>
                                            </Col>
                                        </Row>
                                    </Col>
                                    <Col span={12}>
                                        <Row>
                                            <Col span={8}>
                                                <h6>Ph No.</h6>
                                            </Col>
                                            <Col span={16}>
                                                <p>{preview ? <span className={clsx(classes.greyBg, classes.mediumWidth)}></span> : businessDetails?.mobile || details?.business?.mobile || '---'}</p>
                                            </Col>
                                        </Row>
                                    </Col>
                                    {
                                        (businessDetails?.pan || details?.business?.panNumber) && <Col span={12}>
                                            <Row>
                                                <Col span={6}>
                                                    <h6>{displayPan(businessDetails?.pan || details?.business?.panNumber || '')[0]}</h6>
                                                </Col>
                                                <Col span={18}>
                                                    <p>{preview ? <span className={clsx(classes.greyBg, classes.mediumWidth)}></span> : displayPan(businessDetails?.pan || details?.business?.panNumber || '')[1]}</p>
                                                </Col>
                                            </Row>
                                        </Col>
                                    }
                                    {
                                        (details.includeGst || preview) &&
                                        <Col span={24}>
                                            <Row>
                                                <Col span={4}>
                                                    <h6>GSTIN</h6>
                                                </Col>
                                                <Col span={20}>
                                                    <p>{preview ? <span className={clsx(classes.greyBg, classes.mediumWidth)}></span> : businessDetails?.gst || details?.business?.gstNumber || '---'}</p>
                                                </Col>
                                            </Row>
                                        </Col>
                                    }
                                </Row>
                            </Col>
                            <Col span={12} className={clsx(classes.bill, classes.billbottompadding)}>
                                <Row>
                                    <Col span={24}>
                                        <Row>
                                            <Col span={4}>
                                                <h6>Email</h6>
                                            </Col>
                                            <Col span={20}>
                                                <p className={clsx(classes.emailText)}>{preview ? <span className={clsx(classes.greyBg, classes.mediumWidth)}></span> : businessDetails?.email || details?.business?.email || '---'}</p>
                                            </Col>
                                        </Row>
                                    </Col>
                                    <Col span={12}>
                                        <Row>
                                            <Col span={8}>
                                                <h6>Ph No.</h6>
                                            </Col>
                                            <Col span={16}>
                                                <p>{preview ? <span className={clsx(classes.greyBg, classes.mediumWidth)}></span> : businessDetails?.mobile || details?.business?.mobile || '---'}</p>
                                            </Col>
                                        </Row>
                                    </Col>

                                    {
                                        (businessDetails?.pan || details?.business?.panNumber) && <Col span={12}>
                                            <Row>
                                                <Col span={6}>
                                                    <h6>{displayPan(businessDetails?.pan || details?.business?.panNumber || '')[0]}</h6>
                                                </Col>
                                                <Col span={18}>
                                                    <p>{preview ? <span className={clsx(classes.greyBg, classes.mediumWidth)}></span> : displayPan(businessDetails?.pan || details?.business?.panNumber || '')[1]}</p>
                                                </Col>
                                            </Row>
                                        </Col>
                                    }
                                    {
                                        (details.includeGst || preview) &&
                                        <Col span={24}>
                                            <Row>
                                                <Col span={4}>
                                                    <h6>GSTIN</h6>
                                                </Col>
                                                <Col span={20}>
                                                    <p>{preview ? <span className={clsx(classes.greyBg, classes.mediumWidth)}></span> : businessDetails?.gst || details?.business?.gstNumber || '---'}</p>
                                                </Col>
                                            </Row>
                                        </Col>
                                    }
                                </Row>
                            </Col>
                        </Row>
                    </Col>

                </Row>
                <Row className={clsx(classes.yellowBorderTop)}>
                    <Col xxl={24} xl={24} lg={24} md={24} sm={24} xs={24} className={clsx(classes.billtoppadding, classes.billCustom)}>
                        <Row type="flex" gutter={15}>
                            <Col xxl={details?.business?.logoUri || businessDetails?.logoUri ? 14 : 12}
                                xl={details?.business?.logoUri || businessDetails?.logoUri ? 14 : 12} lg={details?.business?.logoUri || businessDetails?.logoUri ? 14 : 12}
                                md={details?.business?.logoUri || businessDetails?.logoUri ? 14 : 12} sm={details?.business?.logoUri || businessDetails?.logoUri ? 14 : 12}
                                xs={details?.business?.logoUri || businessDetails?.logoUri ? 14 : 12} className={classes.bill}>
                                <h6>Supplier</h6>
                                <h1 style={{ fontFamily: '"RobotoMedium", "Roboto"', marginBottom: 10 }}>{preview ? <span className={clsx(classes.greyBg, classes.mediumWidth)}></span> : details?.supplier?.name || '---'}</h1>
                                <p>{preview ? <span className={clsx(classes.greyBg, classes.largeWidth)}></span> : address(details?.supplier)}</p>
                                <p>{preview ? <span className={clsx(classes.greyBg, classes.mediumWidth)}></span> : address1(details?.supplier)}</p>
                            </Col>
                            <Col xxl={5} xl={5} lg={5} md={5} sm={5} xs={5} style={{ paddingLeft: details?.business?.logoUri || businessDetails?.logoUri ? 35 : 15 }} className={clsx(classes.bill)}>
                                <h6>{copy ? 'Order' : 'Quotation'} Number</h6>
                                <h1 style={{ fontFamily: '"RobotoMedium", "Roboto"' }}>{preview ? <span className={clsx(classes.greyBg, classes.mediumWidth)}></span> : details?.serialNo || '---'}</h1>
                                <h6 className={classes.margin10t}>Created By</h6>
                                <p>{preview ? <span className={clsx(classes.greyBg, classes.mediumWidth)}></span> : details?.quoteCreatedBy || '---'}</p>
                            </Col>
                            <Col xxl={5} xl={5} lg={5} md={5} sm={5} xs={5} className={clsx(classes.bill, classes.textAlignRight)}>

                            </Col>
                        </Row>
                        <Row type="flex" className={classes.margin20t} gutter={15}>
                            <Col xxl={details?.business?.logoUri || businessDetails?.logoUri ? 14 : 12}
                                xl={details?.business?.logoUri ? 14 : 12} lg={details?.business?.logoUri ? 14 : 12}
                                md={details?.business?.logoUri ? 14 : 12} sm={details?.business?.logoUri ? 14 : 12}
                                xs={details?.business?.logoUri ? 14 : 12} className={classes.bill}>
                                <Row className={clsx(classes.bill)}>
                                    <Col span={24}>
                                        <Row>
                                            <Col span={3}>
                                                <h6>Email</h6>
                                            </Col>
                                            <Col span={21}>
                                                <p>{preview ? <span className={clsx(classes.greyBg, classes.mediumWidth)}></span> : details?.supplier?.email || '---'}</p>
                                            </Col>
                                        </Row>
                                    </Col>
                                    <Col span={12}>
                                        <Row>
                                            <Col span={6}>
                                                <h6>Ph No.</h6>
                                            </Col>
                                            <Col span={18}>
                                                <p>{preview ? <span className={clsx(classes.greyBg, classes.mediumWidth)}></span> : details?.supplier?.mobile || '---'}</p>
                                            </Col>
                                        </Row>
                                    </Col>
                                    {
                                        details?.supplier?.pan && <Col span={12}>
                                            <Row>
                                                <Col span={6}>
                                                    <h6>{displayPan(details?.supplier?.pan)[0]}</h6>
                                                </Col>
                                                <Col span={18}>
                                                    <p>{preview ? <span className={clsx(classes.greyBg, classes.mediumWidth)}></span> : displayPan(details?.supplier?.pan)[1]}</p>
                                                </Col>
                                            </Row>
                                        </Col>
                                    }
                                    {
                                        (details.includeGst || preview) && <Col span={24}>
                                            <Row className={classes.overlFlowResponsiveDesign}>
                                                <Col span={3}>
                                                    <h6>GSTIN</h6>
                                                </Col>
                                                <Col span={21}>
                                                    <p>{preview ? <span className={clsx(classes.greyBg, classes.mediumWidth)}></span> : details?.supplier?.gstin || '---'}</p>
                                                </Col>
                                            </Row>
                                        </Col>
                                    }
                                </Row>
                            </Col>
                            <Col xxl={5} xl={5} lg={5} md={5} sm={5} xs={5} style={{ paddingLeft: details?.business?.logoUri || businessDetails?.logoUri ? 35 : 15 }} className={clsx(classes.bill)}>
                                <h6>Date</h6>
                                <p>{preview ? <span className={clsx(classes.greyBg, classes.mediumWidth)}></span> : (details?.createTs ? moment(details?.createTs).format('DD MMM YYYY') : '---') || '---'}</p>
                            </Col>
                            <Col xxl={5} xl={5} lg={5} md={5} sm={5} xs={5} className={clsx(classes.bill, classes.textAlignRight)}>
                                <h6>Delivery Date</h6>
                                <p>{preview ? <span className={clsx(classes.greyBg, classes.mediumWidth)}></span> : (details?.deliveryDate ? moment(details?.deliveryDate).format('DD MMM YYYY') : '---') || '---'}</p>
                            </Col>
                        </Row>
                    </Col>
                </Row>

                <Row className={clsx(classes.secondSection, classes.yellowBorderTop)}>
                    <Col span={details?.reference ? 8 : 16} className={clsx(classes.bill)} style={{ padding: "10px 15px 3px 15px" }}>
                        <div style={{ display: "flex" }}>
                            <h6 style={{ fontSize: "14px" }}>Place of Supply</h6>
                            <p style={{ paddingLeft: "10px", fontSize: "14px" }}>{preview ? <span className={clsx(classes.greyBg, classes.mediumWidth)}></span> : placeOfSupply[4]}</p>
                        </div>
                    </Col>
                    {
                        details?.reference && <Col span={8} className={clsx(classes.borderLeft, classes.bill)} style={{ padding: "10px 15px 3px 15px" }}>
                            <div style={{ display: "flex" }}>
                                <h6 style={{ fontSize: "14px" }}>Reference </h6>
                                <p style={{ paddingLeft: "10px", fontSize: "14px" }}>{preview ? <span className={clsx(classes.greyBg, classes.mediumWidth)}></span> : details?.reference || '---'}</p>
                            </div>
                        </Col>
                    }
                </Row>
                <div className={clsx(classes.yellowBorderTop)}>
                    <div className={clsx(classes.thirdSection)}><SalesLines ref={ref} {...props} terms={true} /></div>
                </div>
            </div>
        </div>
    )
})